export default "__VITE_ASSET__BvsB3QHb__"